import * as THREE from 'three'
import {SectionBase} from "./SectionBase.js";

export default class StabilisierungSection extends SectionBase
{
    constructor(_options)
    {
        super(_options);
    }

    setGeometries() {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes() {
        this.meshes = {}
        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            color: 0xffffff,
            alphaMap: this.resources.items.areaOpenTexture
        }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setItemConfigs() {
        this.list = [
            {
                name: 'keppler',
                x: 215,
                y: -30,
                cameraAngle: 'projects',
                interactionTypes: ['showTexture'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                floorTextureOffsetX:7,
                floorTextureOffsetY:7,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: [
                    {type: 'Stabilisierung', x: 9, y: -6}
                ]
            },

            {
                name: 'keppler',
                x: 230,
                y: -38,
                useTiles: true,
                interactionTypes: ['qualifikation'],
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: [
                    {type: 'Labyrinth', x: 0, y: 30, mass: 0}
                ]
            },
            {
                name: 'keppler',
                x: 245,
                y: -30,
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: []
            },

            {
                name: 'keppler',
                x: 230,
                y: -22,
                interactionTypes: ['miroBoard'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: []
            },
        ]
    }

    setRoads() {
        this.tiles.add({
            start: new THREE.Vector2(205,-32),
            delta: new THREE.Vector2(39,0)
        })
        this.tiles.add({
            start: new THREE.Vector2(215,-40),
            delta: new THREE.Vector2(5,-2)
        })
    }

    setStatic() {

    }

    setWalls() {

        super.setWalls()

        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x +248, this.y -20, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x +249.9, this.y -21, 0),
                    offsetWidth: new THREE.Vector3(0, - 1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })
        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 206, this.y - 20, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })


        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 205, this.y - 22, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })
        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 205, this.y - 27.5, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

    }
}
